import en from './en.json';
import es from './es.json';
import tr from './tr.json';

export const locales = {
    en,
    es,
    tr
};

export const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
];